import * as React from "react";
import styled from "styled-components";
import FormSelect from "../../atom/form/form_select";
import Label from "../../atom/label/label";
import ErrorText from "../../atom/text/error_text";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
  type: string;
  required?: boolean;
  name: string;
  label: string;
  hasError: boolean;
  errorText: string;
  disabled?: boolean;
  input?: any;
  require?: boolean;
  unit?: string;
  backgroundColor?: string;
  fontWeight?: string;
}

const FormGroupSelect: React.FC<IProps> = (props) => {
  const {
    type,
    required,
    name,
    label,
    hasError,
    errorText,
    disabled,
    children,
    input,
    unit,
    require,
    backgroundColor,
    fontWeight,
  } = props;

  return (
    <div>
      {label && (
        <Label require={require} htmlFor={name} marginBottom={true}>
          {label}
        </Label>
      )}
      <FormSelectWrapper>
        <FormSelect
          {...required}
          {...input}
          type={type}
          disabled={disabled}
          style={{ backgroundColor, fontWeight }}
        >
          {children}
        </FormSelect>
        {unit && (
          <UnitWrapper>
            <ParagraphSup bold={true}>{unit}</ParagraphSup>
          </UnitWrapper>
        )}
      </FormSelectWrapper>
      {hasError && <ErrorText>{errorText}</ErrorText>}
    </div>
  );
};

export default FormGroupSelect;

const FormSelectWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`;

const UnitWrapper = styled.div`
  margin-left: 5px;
`;



// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_select.tsx